import {ANCHORS_SELECTOR} from "../constants";
import jump from "jump.js";
import {MEDIA} from "../constants";
import {trigger} from "../../utils/events/trigger";

export const initAnchorsSliding = () => {
	if (document.querySelector(ANCHORS_SELECTOR))
	{
	
		const anchors = Array.from(document.querySelectorAll(ANCHORS_SELECTOR));

		anchors.forEach((anchor) => anchor.addEventListener(`click`, (evt) => {
			if (!document.documentElement.classList.contains(`on-sliding`) && !document.querySelector(`div.lightbox`))
			{
				if ( window.innerWidth < MEDIA.DESKTOP )
				{
					const SITE_MENU = document.querySelector(`input[id="state-switch"]`);

					if ( SITE_MENU.checked )
					{
						trigger(SITE_MENU, `change`, false);
					}
				}
				
				const element = document.querySelector(anchor.hash);
				document.documentElement.classList.add(`on-sliding`);
				element.removeAttribute(`id`);
				location.hash = anchor.hash;
				return jump(element, {
					duration: 700,
					callback: () => {
						element.setAttribute(`id`, anchor.hash.slice(1));
						document.documentElement.classList.remove(`on-sliding`);
					},
				});
			}

			evt.preventDefault();
		}));
	}
};
